import UserPassword from './UserPassword';

export default UserPassword;
